import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  printProduct: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    preview_asset_image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  printSize: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
};

const PrintProductSizeRoesConfiguratorSample = ({
  printProduct,
  printSize,
}) => {
  if (!printProduct || !printProduct?.preview_asset_image?.url) {
    return null;
  }

  return (
    <Fragment>
      <h3 className="text-center">
        See sample for{' '}
        <span className="text-primary">
          {printSize?.name ?? printProduct.name}
        </span>
      </h3>
      <div className="print-product-size-roes-configurator-sample">
        <img src={printProduct.preview_asset_image.url} alt="Preview" />
      </div>
    </Fragment>
  );
};

PrintProductSizeRoesConfiguratorSample.propTypes = propTypes;

export default PrintProductSizeRoesConfiguratorSample;
